module.exports = __webpack_public_path__ + "static/img/no-order.e6b20f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/home/no-order.png
// module id = 729
// module chunks = 137